import "./styles.less";

import { Button, Typography, Grid } from "antd";
import React, { useState } from "react";

import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import { ImagenOptimizada } from "shared-components/Components/Image/web";
import dayjs from "dayjs";
import { useContext } from "react";
import { useEffect } from "react";
import { useGoogleAnalytics } from "shared-components/GlobalHooks/web/GoogleAnalytics.hook";
import { useRouter } from "next/router";

const { Title } = Typography;

const categoryName = "app-promo";
const APP_PROMO_LOCALSTORAGE_KEY = "app_promo_displayed";

dayjs.locale("es");

const { useBreakpoint } = Grid;

export const BannerAppPromotion = () => {
	const START_TIME = dayjs("9/09/2021 10:45", "D/M/YYYY HH:m");
	const END_TIME = dayjs("9/09/2021 12:15", "D/M/YYYY HH:m");
	const d = dayjs();

	const screen = useBreakpoint();

	const { pathname } = useRouter();
	const GA = useGoogleAnalytics();

	const [fade, setFade] = useState(false);
	const [bannerPositionClass, setBannerPositionClass] = useState("position-bottom");
	const { country_code } = useContext(ConfigStateContext);

	const closeAppPromo = action => {
		setFade(true);
		GA.Event({ category: categoryName, action });

		if (action === "open") {
			setTimeout(() => localStorage.setItem(APP_PROMO_LOCALSTORAGE_KEY, "true"), 500);
		} else {
			const now = dayjs().format();
			setTimeout(() => localStorage.setItem(APP_PROMO_LOCALSTORAGE_KEY, now), 500);
		}
	};

	useEffect(() => {
		if (
			pathname === "/projectEspecialSingle" ||
			pathname === "/projectSingle" ||
			pathname === "/propSingle"
		)
			setBannerPositionClass("position-top");
	}, []);

	useEffect(() => {
		const lastDate = dayjs(localStorage.getItem(APP_PROMO_LOCALSTORAGE_KEY));
		if (lastDate) {
			const now = dayjs();
			const res = now.diff(lastDate, "day");
			if (res >= 2) localStorage.removeItem(APP_PROMO_LOCALSTORAGE_KEY);
		}

		if (
			localStorage.getItem(APP_PROMO_LOCALSTORAGE_KEY) != null ||
			(d.isSameOrAfter(START_TIME, "m") && d.isSameOrBefore(END_TIME, "m"))
		) {
			GA.Event({
				category: categoryName,
				action: "show",
			});
		}
	}, []);

	if (
		localStorage.getItem(APP_PROMO_LOCALSTORAGE_KEY) != null ||
		(d.isSameOrAfter(START_TIME, "m") && d.isSameOrBefore(END_TIME, "m"))
	)
		return null;


	if (screen.lg) return null

	return (
		<div
			id="app_promo"
			className={`banner-app-promo animated ${fade
				? `animatedFadeInDown fadeInDown-${bannerPositionClass}`
				: `animatedFadeInUp fadeInUp-${bannerPositionClass}`
				} ${bannerPositionClass}`}>
			<Title className="title" level={5}>
				{"Bajá la app para buscar más fácil y rápido."}
			</Title>
			<div className="container-btns">
				<Button className="btn-close btn" onClick={() => closeAppPromo("close")}>
					{"Ahora no"}
				</Button>
				<Button
					href={country_code == 'ce3' ? "https://onelink.to/x7r2zf" : "http://onelink.to/rhh4cu"}
					target="_blank"
					type="primary"
					className="btn-open btn"
					onClick={() => closeAppPromo("open")}
					rel="nofollow"
				>
					<ImagenOptimizada
						src={
							"https://cdn2.infocasas.com.uy/web/60d9ce710b75b_infocdn__logo_mini.png"
						}
						alt="Logo Infocasas Promo"
						className="logo-ic"
					/>
					{"Abrir"}
				</Button>
			</div>
		</div>
	);
};
